import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import { AccessibilityTokens } from '@vds-tokens/accessibility';
import { ColorTokens } from '@vds-tokens/color';
import { Fonts } from '@vds-core/typography';
import { TypographyTokens } from '@vds-tokens/typography';
var propTypes = {
  children: PropTypes.string.isRequired,
  /**
   * @ignore
   */
  target: PropTypes.oneOf(['', '_blank', '_self', '_parent', '_top']),
  /**
   * @ignore
   */
  href: PropTypes.string,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  hoverState: PropTypes.bool,
  /**
   * @ignore
   */
  focusRingBorderRadius: PropTypes.string
};
var defaultProps = {
  target: '_self',
  hoverState: true,
  focusRingBorderRadius: '2px'
};
var anchorStyles = /*#__PURE__*/css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: none;\n  transition: color 0.15s ease-out;\n  position: relative;\n  cursor: pointer;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  color: ", ";\n  text-decoration: none;\n  outline: none;\n  ", ";\n  &:active {\n    color: ", ";\n  }\n  box-sizing: border-box;\n  ", ";\n"])), Fonts.VerizonNHGeTX, calculateRem(TypographyTokens.fontsize.body[12].value), TypographyTokens.fontweight.regular.value, calculateRem(TypographyTokens.lineheight.body[16].value), function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var focusRingBorderRadius = _ref2.focusRingBorderRadius,
    surface = _ref2.surface;
  return "\n      &:focus:not(:hover) {\n        outline: none;\n        &::before {\n          border: ".concat(calculateRem(AccessibilityTokens.focusring.borderwidth.value), " ").concat(AccessibilityTokens.focusring.borderstyle.value, " ").concat(surface === 'dark' ? AccessibilityTokens.color.focusring.ondark.value : AccessibilityTokens.color.focusring.onlight.value, ";\n          border-radius: ").concat(focusRingBorderRadius, ";\n          content: '';\n          height: calc(100% + ").concat(calculateRem(parseInt(AccessibilityTokens.focusring.space.offset.value) + parseInt(AccessibilityTokens.focusring.borderwidth.value)), ");\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ").concat(calculateRem(4), ");\n        }\n      }\n  ");
}, function (_ref3) {
  var surface = _ref3.surface;
  return surface === 'dark' ? ColorTokens.interactive.active.ondark.value : ColorTokens.interactive.active.onlight.value;
}, function (_ref4) {
  var hoverState = _ref4.hoverState,
    surface = _ref4.surface;
  return hoverState && "\n    &:hover:not(:active) {\n      &::before {\n        background: ".concat(surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value, ";\n        position: absolute;\n        box-shadow: none;\n        content: '';\n        height: 1px;\n        bottom: 0;\n        width: 100%;\n        z-index: 1;\n      }\n    }\n  ");
});
var StyledAnchor = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledAnchor",
  componentId: "VDS__sc-htyi4p-0"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), anchorStyles);
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "VDS__sc-htyi4p-1"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  background: transparent;\n  border: none;\n  padding: 0;\n"])), anchorStyles);

/**
 * @ignore
 */
var BreadcrumbAnchor = function BreadcrumbAnchor(props) {
  var href = props.href,
    target = props.target,
    children = props.children,
    ariaLabel = props.ariaLabel,
    surface = props.surface,
    color = props.color,
    hoverState = props.hoverState,
    analyticsTrack = props['data-analyticstrack'],
    track = props['data-track'],
    trackIgnore = props['data-track-ignore'],
    clickStream = props['data-clickstream'],
    focusRingBorderRadius = props.focusRingBorderRadius;
  var _renderColor = function _renderColor() {
    if (color) return color;else if (surface === 'dark') {
      return ColorTokens.elements.primary.ondark.value;
    } else return ColorTokens.elements.primary.onlight.value;
  };
  function _onClick(e) {
    if (e.type === 'click') {
      e.currentTarget.blur();
    }
    props.onClick && props.onClick(e);
  }
  var StyledBreadcrumbAnchor = href ? StyledAnchor : StyledButton;
  return /*#__PURE__*/React.createElement(StyledBreadcrumbAnchor, {
    href: href,
    target: target,
    "aria-label": ariaLabel,
    role: href ? 'link' : 'button',
    tabIndex: 0,
    onClick: _onClick,
    color: _renderColor(),
    surface: surface,
    hoverState: hoverState,
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-track-ignore": trackIgnore,
    "data-clickstream": clickStream,
    focusRingBorderRadius: focusRingBorderRadius
  }, children);
};
BreadcrumbAnchor.propTypes = propTypes;
BreadcrumbAnchor.defaultProps = defaultProps;
export default BreadcrumbAnchor;